'use client';

import styled from '@emotion/styled';
import Button from '../../../components/common/button/Button';
import { PaginationWrap } from '../../../components/common/Pagination/Pagination.styles';
import { ArrowForwardIcon, Css, ITheme } from '../../../ui';
import { Color } from '../../../styles/Color';

interface IProps {
	currentPageIndex: number;
	totalPages: number;
	onPageChange: (newPageIndex: number) => void;
}

export function ShopDineRelaxPagination({
	currentPageIndex,
	totalPages,
	onPageChange,
}: IProps) {
	const prevDisabled = currentPageIndex === 0;
	const nextDisabled = currentPageIndex === totalPages - 1;

	return (
		<PaginationWrap>
			<PaginationButtonWrap disabled={prevDisabled}>
				<StyledButton
					disabled={prevDisabled}
					aria-disabled={prevDisabled}
					ariaLabel="Go Back"
					icon={
						<ArrowForwardIcon
							style={{ transform: 'rotate(180deg)' }}
							aria-label="Go Back"
						/>
					}
					onClick={() => onPageChange(currentPageIndex - 1)}
				/>

				<PaginationButtonLabel disabled={prevDisabled}>
					Back
				</PaginationButtonLabel>
			</PaginationButtonWrap>

			<PaginationButtonWrap disabled={nextDisabled}>
				<PaginationButtonLabel disabled={nextDisabled}>
					Next
				</PaginationButtonLabel>

				<StyledButton
					disabled={nextDisabled}
					aria-disabled={nextDisabled}
					ariaLabel="Go to next page"
					onClick={() => onPageChange(currentPageIndex + 1)}
				/>
			</PaginationButtonWrap>
		</PaginationWrap>
	);
}

const StyledButton = styled(Button)`
	padding: ${Css.pxToRem(10)};
`;

const PaginationButtonWrap = styled.div<{ disabled: boolean }, ITheme>`
	display: flex;
	align-items: center;
	gap: ${Css.pxToRem(8)};
	cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

	${({ disabled, theme }) =>
		!disabled &&
		`
			&:hover ${StyledButton} {
				background: ${theme.button?.primary?.hover?.background};
				border-color: ${theme.button?.primary?.hover?.background};
				color: ${theme.button?.primary?.hover?.font?.color};
			}
			&:focus ${StyledButton} {
				background: ${theme.button?.primary?.focus?.background};
				color: ${theme.button?.primary?.focus?.font?.color};
			}
		`}
`;

const PaginationButtonLabel = styled.div<{ disabled: boolean }, ITheme>`
	font-weight: 700;
	font-size: ${Css.pxToRem(16)};
	color: ${({ disabled }) => (disabled ? Color.Neutral6 : Color.DarkLabel)};
`;
